const isUnset = (value) => value === undefined || value === null || value === '';

export const getDependencyChange = (previous = [], current = []) => {
	const changedIndexes = current.reduce(
		(indexes, value, index) => (previous[index] === value ? indexes : [...indexes, index]),
		[]
	);

	return {
		hasChanged: changedIndexes.length > 0,
		isInitialSettle:
			changedIndexes.length > 0 &&
			changedIndexes.every((index) => isUnset(previous[index]))
	};
};
